import { DatePipe, NgClass, NgStyle } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ConfirmationService, MenuItem, MessageService, PrimeTemplate } from 'primeng/api';
import { Button } from 'primeng/button';
import { Card } from 'primeng/card';
import { Dialog } from 'primeng/dialog';
import { Step, StepList, Stepper } from 'primeng/stepper';
import { TableModule, TableRowSelectEvent } from 'primeng/table';
import { Tag } from 'primeng/tag';
import { Tooltip } from 'primeng/tooltip';
import { Observable, Subject, Subscription } from 'rxjs';
import { BaseComponent } from '../../../content/components/base/base.component';
import { DbNoDataInfoComponent } from '../../../content/components/dashboard/custom-views/db-no-data-info/db-no-data-info.component';
import { AddFormPaymentPageLinkGeneralComponent } from '../../../content/components/payment-page/add-form-payment-page-link-general/add-form-payment-page-link-general.component';
import { AddFormPaymentPageLinkIntegrationComponent } from '../../../content/components/payment-page/add-form-payment-page-link-integration/add-form-payment-page-link-integration.component';
import { AddFormPaymentPageLinkPaymentComponent } from '../../../content/components/payment-page/add-form-payment-page-link-payment/add-form-payment-page-link-payment.component';
import { AddFormPaymentPageLinkPresentationComponent } from '../../../content/components/payment-page/add-form-payment-page-link-presentation/add-form-payment-page-link-presentation.component';
import { AddFormPaymentPageComponent } from '../../../content/components/payment-page/add-form-payment-page/add-form-payment-page.component';
import { EditFormAdministrationDataComponent } from '../../../content/components/payment-page/edit-form-administration-data/edit-form-administration-data.component';
import { PaymentPageDataCreate } from '../../../content/dtos/payment-page/payment-page-data-create';
import { EditPaymentPageDialogType } from '../../../content/enums/payment/edit-payment-page-dialog-type';
import { PaymentPageLinkDialogType } from '../../../content/enums/payment/payment-page-link-dialog-type';
import { DialogControl } from '../../../content/interfaces/dialog-control';
import { DialogTableDataRow } from '../../../content/interfaces/dialog-table-data-row';
import { EditPaymentPageDialog } from '../../../content/interfaces/payment-page/edit-payment-page-dialog';
import { PaymentPageData } from '../../../content/interfaces/payment-page/payment-page-data';
import { PaymentPageInvalidFlags } from '../../../content/interfaces/payment-page/payment-page-invalid-flags';
import { PaymentPageLinkData } from '../../../content/interfaces/payment-page/payment-page-link-data';
import { PaymentPageLinkDialog } from '../../../content/interfaces/payment-page/payment-page-link-dialog';
import { PaymentPageLinkInvalidFlags } from '../../../content/interfaces/payment-page/payment-page-link-invalid-flags';
import { PaymentData } from '../../../content/interfaces/payment/payment-data';
import { AdministrationToTableDataMapper } from '../../../content/mapper/payment-page/administration-to-table-data-mapper.service';
import { PaymentPageLinkMapper } from '../../../content/mapper/payment-page/payment-page-link-mapper.service';
import { TechDataToTableDataMapper } from '../../../content/mapper/payment-page/tech-data-to-table-data-mapper.service';
import { PaymentDataService } from '../../../content/services/payment-data.service';
import { PaymentPageLinkService } from '../../../content/services/payment-page-link.service';
import { SERVICE_ENDPOINTS } from '../../../core/configs/service-endpoints';
import { HelperService } from '../../../core/services/helper.service';
import { I18nService } from '../../../core/services/i18n.service';
import { LayoutService } from '../../../layout/services/layout.service';
import { SpsCustomIconComponent } from '../sps-custom-icon/sps-custom-icon.component';
import { PaymentMethodDataCardComponent } from '../sps-payment-method-data-card/payment-method-data-card.component';

@Component({
  selector: 'sps-payment-page',
  imports: [
    Button,
    Card,
    DbNoDataInfoComponent,
    PaymentMethodDataCardComponent,
    PrimeTemplate,
    NgClass,
    TableModule,
    SpsCustomIconComponent,
    DatePipe,
    Tag,
    Dialog,
    EditFormAdministrationDataComponent,
    Stepper,
    StepList,
    Step,
    AddFormPaymentPageLinkGeneralComponent,
    AddFormPaymentPageLinkPaymentComponent,
    AddFormPaymentPageLinkPresentationComponent,
    AddFormPaymentPageLinkIntegrationComponent,
    AddFormPaymentPageComponent,
    NgStyle,
    Tooltip
  ],
  templateUrl: './sps-payment-page.component.html'
})
export class SpsPaymentPageComponent extends BaseComponent implements OnInit, AfterViewInit {

  @Input() paymentPageData: PaymentPageData = null;
  @Input() scrollHeightOffset: number = 236;
  /**
   * Emitter for new payment page
   */
  @Output() addNewPaymentPage = new EventEmitter<PaymentPageDataCreate>();
  /**
   * Emitter for changed payment page
   */
  @Output() changePaymentPage = new EventEmitter<PaymentPageData>();

  totalRecords: number = 0;

  /**
   * Data für Payment-Page-Data Cards
   */
  tableDataPaymentPageAdmin: DialogTableDataRow[] = [];
  tableDataPaymentPageTechSpecs: DialogTableDataRow[] = [];

  /**
   * Payment-Page links
   */
  paymentPageLinks: PaymentPageLinkData[] = [];
  selectedRowData: PaymentPageLinkData | PaymentPageLinkData[] = null;

  /**
   * Add link menu
   */
  addLinkMenu: MenuItem[] = [];
  menuShown: boolean = false;

  /**
   * Dialog-Control for Payment Page edit dialogs
   */
  editPaymentPageDialog: EditPaymentPageDialog = {visible: false};
  paymentPageDataResetClone: PaymentPageData = null;
  protected readonly PaymentPageDialogType = EditPaymentPageDialogType;
  paymentPageInvalidFlags: PaymentPageInvalidFlags;
  lastPaymentPageStatus: "LIVE" | "TEST" | "CLOSED" | "DELETED";

  /**
   * Dialog-Control for  Add-Payment-Page dialog
   */
  addPaymentPageDialog: DialogControl = {visible: false};
  newPaymentPageData: PaymentPageDataCreate = null;

  /**
   * Dialog-Control for Payment-Page-Link dialogs
   * (add/edit link data)
   */
  paymentPageLinkDialog: PaymentPageLinkDialog = {visible: false};
  paymentPageLinkActiveStep: number = 1;
  paymentPageLinkData: PaymentPageLinkData = null;
  paymentPageLinkDataChangedCheckObject: PaymentPageLinkData = null;
  paymentPageLinkInvalidFlags: PaymentPageLinkInvalidFlags;
  private paymentPageLinkSaved = new Subject<boolean>();
  private paymentPageLinksSaved = new Subject<boolean>();

  /**
   * Payment-Links Table-Options
   */
  rows: number = 20;
  rowsPerPageOptions = [10, 20, 50, 100];
  minScrollHeight: number = 160;

  /**
   * List of available payment-types for the payment page
   * LIVE-PaymentTypes for LIVE PaymentPage
   * TEST-PaymentTypes for TEST PaymentPage
   */
  paymentPagePaymentTypes: PaymentData[] = [];
  paymentPageLinkPaymentTypes: PaymentData[] = [];

  constructor(public i18n: I18nService,
              public layoutService: LayoutService,
              public helperService: HelperService,
              private confirmationService: ConfirmationService,
              private messageService: MessageService,
              public paymentDataService: PaymentDataService,
              private paymentPageLinkService: PaymentPageLinkService,
              private paymentPageLinkMapper: PaymentPageLinkMapper,
              private administrationDataMapper: AdministrationToTableDataMapper,
              private techDataMapper: TechDataToTableDataMapper) {
    super();
  }

  ngOnInit() {
    this.loading = true;
    this.addLinkMenu = [
      {
        id: 'ADDPAYMENTLINK',
        label: this.i18n.i18nLng()['MENUADDPAYMENTLINK'],
        command: () => {
          this.showAddLinkDialog('PAYMENT');
        },
        tooltip: this.i18n.i18nLng()['ADDPAYMENTLINKINFO']
      },
      {
        id: 'ADDDONATIONLINK',
        label: this.i18n.i18nLng()['MENUADDDONATIONLINK'],
        command: () => {
          this.showAddLinkDialog('DONATION');
        },
        tooltip: this.i18n.i18nLng()['ADDDONATIONLINKINFO']
      }
    ];

    if (this.paymentPageData) {
      /**
       * now all payment types for the current tenant are selectable - TEST and LIVE
       * the filtering is done by the remote, laravel payment page
       */
      // this.paymentPagePaymentTypes = this.paymentDataService.paymentTypes.filter(item => item.status === this.paymentPageData.status);
      this.paymentPagePaymentTypes = this.paymentDataService.paymentTypes.sort((a, b) => {
        const methodA = a.paymentMethod || '';
        const methodB = b.paymentMethod || '';
        return methodA.localeCompare(methodB);
      });
      this.mapPaymentTableData();
      this.initPaymentPageLinks();
      this.initPaymentPageLinksPaymentTypes();
    } else {
      this.totalRecords = this.paymentPageLinks.length;
      this.loading = false;
    }
  }

  ngAfterViewInit(): void {
    /**
     * Some controls need refresh after language-changes
     */
    this.subscriptions.add(
      this.i18n.languageChanged.subscribe({
        next: value => {
          this.refreshControls = true;
          setTimeout(() => {
            this.refreshControls = false;
          }, 10);
        }
      })
    );
  }

  /**
   * Init data for all payment page links
   * Service for PaymentPageLinks is LazyLoading for future use, now data will be loaded eager
   */
  private initPaymentPageLinks(): void {
    this.paymentPageLinkService.findPage(this.helperService.eagerLazyLoadEvent(), this.paymentPageData.id).subscribe({
      next: result => {
        if (result.successful) {
          this.paymentPageLinks = result.payload;
          /**
           * Map amount from cent to decimal
           */
          this.paymentPageLinks.map(linkData => {
            linkData.amount = linkData.amount / 100;
            if (linkData?.expirationDate) {
              linkData.expirationDate = new Date(linkData.expirationDate);
            }
          })
          this.totalRecords = result.totalElements;
        } else {
          this.messageService.add({
            sticky: true,
            severity: 'error',
            summary: this.i18n.i18nLng()['HTTPDATAERROR'],
            detail: result.message + '\n' + result.details + '\n' + this.i18n.i18nLng()['CONTACTSUPPORT']
          });
          this.totalRecords = 0;
          this.loading = false;
        }
      },
      error: err => {
        this.messageService.add({
          sticky: true,
          severity: 'error',
          summary: this.i18n.i18nLng()['HTTPDATAERROR'],
          detail: err.message + '\n' + this.i18n.i18nLng()['CONTACTSUPPORT']
        });
        this.totalRecords = 0;
        this.loading = false;
      }
    });
  }

  /**
   * if payment types are selected, only this payment types are
   * available for the payment page links
   * @private
   */
  private initPaymentPageLinksPaymentTypes(): void {
    this.paymentPageLinkPaymentTypes = [];
    if (this.paymentPageData?.paymentTypeIds.length > 0) {
      this.paymentPagePaymentTypes.map(paymentType => {
        if (this.paymentPageData.paymentTypeIds.includes(paymentType.id)) {
          this.paymentPageLinkPaymentTypes.push(paymentType);
        }
      })
    } else {
      // no payment page links are selected for the payment page, so all payment type of the tenant are available
      this.paymentPageLinkPaymentTypes = this.paymentPagePaymentTypes;
    }
  }


  showEditDialog(paymentPageDialogType: EditPaymentPageDialogType) {
    this.resetPaymentPageInvalidFlags();
    this.paymentPageDataResetClone = this.helperService.jsonCopy(this.paymentPageData);
    this.editPaymentPageDialog = {
      type: paymentPageDialogType,
      visible: true
    };
    switch (paymentPageDialogType) {
      case EditPaymentPageDialogType.ADMINISTRATION:
        /**
         * Remember the current PaymentPage-Status (LIVE/TEST)
         * to inform the user that the PaymentType-Relations of the
         * Payment- and  Donation-Links will be resetted if the status changed
         */
        this.lastPaymentPageStatus = this.paymentPageData.status;
        this.editPaymentPageDialog.i18nTitleKey = 'EDITPAYMENTPAGEADMIN';
        break;
    }
  }

  showAddLinkDialog(linkType: 'PAYMENT' | 'DONATION') {
    this.resetPaymentPageLinkInvalidFlags();
    this.paymentPageLinkActiveStep = 1;
    this.paymentPageLinkDialog.linkType = linkType;
    this.initNewPaymentPageLinkData();
    this.dataValid = false;
    this.paymentPageLinkDialog.type = PaymentPageLinkDialogType.ADD;
    this.paymentPageLinkDialog.visible = true;
    if (linkType === 'PAYMENT') {
      this.paymentPageLinkDialog.i18nTitleKey = 'MENUADDPAYMENTLINK';
    } else {
      this.paymentPageLinkDialog.i18nTitleKey = 'MENUADDDONATIONLINK';
    }
  }

  showEditLinkDialog(linkType: 'PAYMENT' | 'DONATION') {
    this.resetPaymentPageLinkInvalidFlags();
    this.dataValid = true;
    this.paymentPageLinkActiveStep = 1;
    this.paymentPageLinkDialog.linkType = linkType;
    this.paymentPageLinkDialog.type = PaymentPageLinkDialogType.EDIT;
    this.paymentPageLinkDialog.visible = true;
    if (linkType === 'PAYMENT') {
      this.paymentPageLinkDialog.i18nTitleKey = 'EDITPAYMENTLINK';
    } else {
      this.paymentPageLinkDialog.i18nTitleKey = 'EDITDONATIONLINK';
    }
  }

  /**
   * add new payment page
   */
  addPaymentPage() {
    this.newPaymentPageData = {
      name: '',
      status: 'TEST',
      paymentTypeIds: [],
    };
    this.addPaymentPageDialog.visible = true;
  }

  onRowSelected(event: TableRowSelectEvent) {
    this.selectedRowData = event.data;
    this.paymentPageLinkData = this.helperService.jsonCopy(this.selectedRowData);
    this.paymentPageLinkDataChangedCheckObject = this.helperService.jsonCopy(this.paymentPageLinkData);
    this.showEditLinkDialog(this.paymentPageLinkData.type);
  }

  /**
   * Cancel Edit-Dialog
   * Reset data from Reset-Clone
   */
  cancelEditPaymentPageData() {
    this.paymentPageData.status = this.paymentPageDataResetClone.status;
    this.paymentPageData.name = this.paymentPageDataResetClone.name;
    this.editPaymentPageDialog.visible = false;
  }

  /**
   * Check changed paymentPageData before the persistence
   */
    checkChangedPaymentPageData() {
    /**
     * Check valid payment-page data
     */
    let valid: boolean = true;
    this.resetPaymentPageInvalidFlags();
    if (!this.paymentPageData?.name || this.paymentPageData.name?.trim().length === 0) {
      valid = false;
      this.paymentPageInvalidFlags.name = true;
    }

    if (valid) {
      let changedLinks: string[] = [];
      this.paymentPageLinks.map(link => {
        if (link.paymentTypeIds.length > 0) {
          link.paymentTypeIds = [];
          changedLinks.push(link.id);
        }
      });
      /**
       * not longer needed remote payment page (laravel) is checking the payment type status
       */
      /*
      if (((this.lastPaymentPageStatus === 'LIVE' && this.paymentPageData.status === 'TEST') || (this.lastPaymentPageStatus === 'TEST' && this.paymentPageData.status === 'LIVE')) && (changedLinks.length > 0)) {
        this.confirmationService.confirm({
          position: 'center',
          message: this.i18n.i18nLng()['CONFIRMPPSTATUSCHANGED'],
          header: this.i18n.i18nLng()['CHANGECONFIRMATION'],
          closable: true,
          closeOnEscape: true,
          icon: 'pi pi-exclamation-triangle',
          acceptButtonProps: {
            label: this.i18n.i18nLng()['YES']
          },
          rejectButtonProps: {
            label: this.i18n.i18nLng()['NO'],
            outlined: true,
            severity: 'secondary'
          },
          accept: () => {
            const subscription: Subscription = this.saveAllChangedPaymentLinks(changedLinks, 0).subscribe({
              next: result => {
                subscription.unsubscribe();
                if (result) {
                  this.saveChangedPaymentPageData();
                }
              }
            })
          },
          reject: () => {
            this.paymentPageData.status = this.lastPaymentPageStatus
            this.saveChangedPaymentPageData();
          }
        });
      } else {
        this.saveChangedPaymentPageData();
      }
       */

      this.saveChangedPaymentPageData();

    }
  }

  /**
   * Data-Persistence of the changed PaymentPage Data
   */
  saveChangedPaymentPageData() {
    /**
     * Reinitialize the paymentPagePaymentMethods in case status changed
     */
    this.editPaymentPageDialog.visible = false;
    this.changePaymentPage.emit(this.paymentPageData);
    this.mapPaymentTableData();
    this.initPaymentPageLinksPaymentTypes();
  }

  /**
   * Save all changed payment links recursive
   * @param paymentLinkIds
   * @param index
   * @private
   */
  private saveAllChangedPaymentLinks(paymentLinkIds: string[], index: number = 0): Observable<boolean> {
    this.paymentPageLinkData = this.paymentPageLinks.find(link => link.id === paymentLinkIds[index]);
    const subscription: Subscription = this.savePaymentPageLink(false).subscribe({
      next: result => {
        subscription.unsubscribe();
        if (result) {
          index++;
          if (index === paymentLinkIds.length) {
            this.paymentPageLinksSaved.next(true);
          } else {
            this.saveAllChangedPaymentLinks(paymentLinkIds, index);
          }
        } else {
          this.paymentPageLinksSaved.next(false);
        }
      }
    })
    return this.paymentPageLinksSaved.asObservable();
  }

  /**
   * Check data and call persistence api
   * called from dialog or from saveAllChangedPaymentLinks
   */
  savePaymentPageLink(saveFromDialog: boolean = true): Observable<boolean> {
    let valid: boolean = true;
    if (saveFromDialog) {
      if (!this.paymentPageLinkData?.buttonText || this.paymentPageLinkData?.buttonText.trim().length === 0) {
        valid = false;
        this.paymentPageLinkInvalidFlags.buttonText = true;
      }
      if (!this.paymentPageLinkData?.languageKey) {
        valid = false;
        this.paymentPageLinkInvalidFlags.languageKey = true;
      }
    }
    if (valid) {
      this.paymentPageLinkDataChangedCheckObject = this.helperService.jsonCopy(this.paymentPageLinkData);
      this.resetPaymentPageLinkInvalidFlags();
      /**
       * Amount to cent
       */
      this.paymentPageLinkData.amount = Math.floor(this.paymentPageLinkData.amount * 100);
      /**
       * if from PaymentPage-Administration then always as update (!saveFromDialog)
       */
      if (!saveFromDialog ||  this.paymentPageLinkDialog.type === PaymentPageLinkDialogType.EDIT) {
        /**
         * map by destruction
         */
        const changedPaymentPageLink = this.paymentPageLinkMapper.mapToUpdate(this.paymentPageLinkData);
        this.paymentPageLinkService.update(SERVICE_ENDPOINTS.UPDATE_PAYMENT_PAGE_LINK + changedPaymentPageLink.id, changedPaymentPageLink).subscribe({
          next: result => {
            if (result.successful) {
              this.paymentPageLinkData = result.dto;
              this.paymentPageLinkDataChangedCheckObject = this.helperService.jsonCopy(this.paymentPageLinkData);
              if (saveFromDialog) {
                this.messageService.add({
                  life: 3500,
                  severity: 'success',
                  summary: this.paymentPageLinkDialog.linkType === 'PAYMENT' ? this.i18n.i18nLng()['EDITPAYMENTLINK'] : this.i18n.i18nLng()['EDITDONATIONLINK'],
                  detail: this.i18n.i18nLng()['HTTPDATAUPDATESUCCESS']
                });
                /**
                 * refresh table
                 */
                this.initPaymentPageLinks();
                /**
                 * show QR-Code page
                 */
                this.paymentPageLinkActiveStep = 4;
              }
              this.paymentPageLinkSaved.next(true);
            } else {
              this.messageService.add({
                sticky: true,
                severity: 'error',
                summary: this.i18n.i18nLng()['HTTPDATAERROR'],
                detail: result.message + '\n' + result.details + '\n' + this.i18n.i18nLng()['CONTACTSUPPORT']
              });
              this.paymentPageLinkSaved.next(false);
            }

          },
          error: (err) => {
            this.messageService.add({
              sticky: true,
              severity: 'error',
              summary: this.i18n.i18nLng()['HTTPDATAERROR'],
              detail: err.message + '\n' + this.i18n.i18nLng()['CONTACTSUPPORT']
            });
            this.paymentPageLinkSaved.next(false);
          }
        })

      } else {
        /**
         * map by destruction
         */
        const newPaymentPageLink = this.paymentPageLinkMapper.mapToCreate(this.paymentPageLinkData);
        /**
         * Save new payment-page-link
         */
        this.paymentPageLinkService.create(SERVICE_ENDPOINTS.CREATE_PAYMENT_PAGE_LINK, newPaymentPageLink).subscribe({
          next: (result) => {
            if (result.successful) {
              this.paymentPageLinkData = result.dto
              this.paymentPageLinkDataChangedCheckObject = this.helperService.jsonCopy(this.paymentPageLinkData);
              this.messageService.add({
                life: 3500,
                severity: 'success',
                summary: this.i18n.i18nLng()['ADDPAYMENTLINK'],
                detail: this.i18n.i18nLng()['HTTPDATACREATESUCCESS']
              });
              /**
               * refresh table
               */
              this.initPaymentPageLinks();
              /**
               * show QR-Code page
               */
              this.paymentPageLinkActiveStep = 4;
              this.paymentPageLinkSaved.next(true);
            } else {
              this.messageService.add({
                sticky: true,
                severity: 'error',
                summary: this.i18n.i18nLng()['HTTPDATAERROR'],
                detail: result.message + ' ' + result.details
              });
              this.paymentPageLinkSaved.next(false);
            }
          },
          error: (err) => {
            this.messageService.add({
              sticky: true,
              severity: 'error',
              summary: this.i18n.i18nLng()['HTTPDATAERROR'],
              detail: err.message
            });
            this.paymentPageLinkSaved.next(false);
          }
        })
      }
    } else {
      setTimeout(() => {
        this.paymentPageLinkSaved.next(false);
      }, 10);
    }
    return this.paymentPageLinkSaved.asObservable();
  }

  cancelAddPaymentPageLink() {
    if (JSON.stringify(this.paymentPageLinkData) !== JSON.stringify(this.paymentPageLinkDataChangedCheckObject)) {
      this.confirmationService.confirm({
        position: 'center',
        message: this.i18n.i18nLng()['CONFIRMCHANGEFLAG'],
        header: this.i18n.i18nLng()['CANCELCONFIRMATION'],
        closable: true,
        closeOnEscape: true,
        icon: 'pi pi-exclamation-triangle',
        acceptButtonProps: {
          label: this.i18n.i18nLng()['YES']
        },
        rejectButtonProps: {
          label: this.i18n.i18nLng()['NO'],
          outlined: true,
          severity: 'secondary'
        },
        accept: () => {
          this.paymentPageLinkDialog.visible = false;
          this.paymentPageLinkActiveStep = 1;
          this.paymentPageLinkData = this.helperService.jsonCopy(this.paymentPageLinkDataChangedCheckObject);
          this.selectedRowData = this.paymentPageLinkData;
          this.selectedRowData = null;
        },
      });
    } else {
      this.paymentPageLinkDialog.visible = false;
      this.paymentPageLinkActiveStep = 1;
      this.selectedRowData = null;
    }
  }

  /**
   * Reset all invalid flags for payment-page data
   * @private
   */
  private resetPaymentPageInvalidFlags() {
    this.paymentPageInvalidFlags = {
      name: false
    };
  }

  /**
   * Map data for the data-info cards
   * @private
   */
  private mapPaymentTableData() {
    this.tableDataPaymentPageAdmin = this.administrationDataMapper.map(this.paymentPageData);
    this.tableDataPaymentPageTechSpecs = this.techDataMapper.map(this.paymentPageData);
  }

  /**
   * init base-data for the new payment-page-link interface
   * @private
   */
  private initNewPaymentPageLinkData() {
    this.paymentPageLinkData = {
      id: null,
      pageId: this.paymentPageData.id,
      type: this.paymentPageLinkDialog.linkType,
      enabled: true,
      name: null,
      purpose: null,
      organisationName: null,
      requestDonationReceiptData: null,
      currency: 'EUR',
      amount: null,
      donationAmountList: (this.paymentPageLinkDialog.linkType === 'DONATION' ? [] : null),
      amountType: (this.paymentPageLinkDialog.linkType === 'DONATION' ? 'CUSTOM' : null),
      customAmountOption: null,
      linkValidity: null,
      expirationDate: null,
      paymentFrequency: null,
      paymentTypeIds: [],
      buttonText: 'Bezahlen',
      languageKey: 'de',
      cssClassName: null,
      merchantTxId: null,
      informationText: null,
      donationProjectList: (this.paymentPageLinkDialog.linkType === 'DONATION' ? [] : null),
      link: null,
      buttonHtmlCode: null,
      // link: 'https://www.s-publicservices.de/',
      // buttonHtmlCode: '<p-button label="Link" [link]="true" />\n<a href="https://angular.dev/" target="_blank" rel="noopener noreferrer" class="p-button font-bold">\n  External\n</a>\n<a routerLink="/" class="p-button font-bold">  Router\n</a>'
    };
    this.paymentPageLinkDataChangedCheckObject = this.helperService.jsonCopy(this.paymentPageLinkData);
  }

  private resetPaymentPageLinkInvalidFlags() {
    this.paymentPageLinkInvalidFlags = {
      name: false,
      purpose: false,
      organisationName: false,
      currency: false,
      amount: false
    };
  }

  /**
   * go to next link step
   */
  nextLinkStep() {
    this.resetPaymentPageInvalidFlags();
    let valid: boolean = true;
    switch (this.paymentPageLinkActiveStep) {
      case 1:
        if (!this.paymentPageLinkData?.name || this.paymentPageLinkData?.name.trim().length === 0) {
          valid = false;
          this.paymentPageLinkInvalidFlags.name = true;
        }
        if (!this.paymentPageLinkData?.purpose || this.paymentPageLinkData?.purpose.trim().length === 0) {
          valid = false;
          this.paymentPageLinkInvalidFlags.purpose = true;
        }
        if (!this.paymentPageLinkData?.organisationName || this.paymentPageLinkData?.organisationName.trim().length === 0) {
          valid = false;
          this.paymentPageLinkInvalidFlags.organisationName = true;
        }
        if (valid) {
          this.resetPaymentPageLinkInvalidFlags();
          this.paymentPageLinkActiveStep = 2;
        }
        break;
      case 2: {
        if (this.paymentPageLinkDialog.linkType === 'PAYMENT') {
          if (!this.paymentPageLinkData?.amount || this.paymentPageLinkData?.amount === 0) {
            valid = false;
            this.paymentPageLinkInvalidFlags.amount = true;
          }
        } else {
          if (this.paymentPageLinkData.amountType === 'FIXED') {
            if (!this.paymentPageLinkData.donationAmountList || this.paymentPageLinkData.donationAmountList.length === 0) {
              valid = false;
              this.paymentPageLinkInvalidFlags.amount = true;
            }
          }
        }
        if (!this.paymentPageLinkData?.linkValidity) {
          valid = false;
          this.paymentPageLinkInvalidFlags.linkValidity = true;
        }
        if (this.paymentPageLinkData?.linkValidity === 'DATE' && !this.paymentPageLinkData?.expirationDate) {
          valid = false;
          this.paymentPageLinkInvalidFlags.expirationDate = true;
        }
        if (!this.paymentPageLinkData?.paymentFrequency) {
          valid = false;
          this.paymentPageLinkInvalidFlags.paymentFrequency = true;
        }
        if (this.paymentPageLinkData?.paymentTypeIds.length === 0) {
          valid = false;
          this.paymentPageLinkInvalidFlags.paymentMethodIds = true;
        }
        if (valid) {
          this.resetPaymentPageLinkInvalidFlags();
          this.paymentPageLinkActiveStep = 3;
        }
        break;
      }
    }
    this.linkDataChanged(this.paymentPageLinkActiveStep);
  }

  /**
   * go to prevoius step
   */
  previousLinkStep() {
    this.paymentPageLinkActiveStep = this.paymentPageLinkActiveStep - 1
    this.linkDataChanged(this.paymentPageLinkActiveStep);
  }

  /**
   * Check for valid link data in specific step to enable next-button
   * @param paymentPageLinkActiveStep
   */
  linkDataChanged(paymentPageLinkActiveStep: number) {
    let valid: boolean = true;
    switch (paymentPageLinkActiveStep) {
      case 1:
        if (!this.paymentPageLinkData?.name || this.paymentPageLinkData?.name.trim().length === 0) {
          valid = false;
        }
        if (!this.paymentPageLinkData?.purpose || this.paymentPageLinkData?.purpose.trim().length === 0) {
          valid = false;
        }
        if (!this.paymentPageLinkData?.organisationName || this.paymentPageLinkData?.organisationName.trim().length === 0) {
          valid = false;
        }
        break;
      case 2:
        if (this.paymentPageLinkDialog.linkType === 'PAYMENT') {
          if (!this.paymentPageLinkData?.amount || this.paymentPageLinkData?.amount === 0) {
            valid = false;
          }
        } else {
          if (this.paymentPageLinkData.amountType === 'FIXED') {
            if (!this.paymentPageLinkData.donationAmountList || this.paymentPageLinkData.donationAmountList.length === 0) {
              valid = false;
            }
          }
        }
        if (!this.paymentPageLinkData?.linkValidity) {
          valid = false;
        }
        if (this.paymentPageLinkData?.linkValidity === 'DATE' && !this.paymentPageLinkData?.expirationDate) {
          valid = false;
        }
        if (!this.paymentPageLinkData?.paymentFrequency) {
          valid = false;
        }
        if (this.paymentPageLinkData?.paymentTypeIds.length === 0) {
          valid = false;
        }
        break;
      case 3:
        if (!this.paymentPageLinkData?.buttonText || this.paymentPageLinkData?.buttonText.trim().length === 0) {
          valid = false;
        }
        if (!this.paymentPageLinkData?.languageKey || this.paymentPageLinkData?.languageKey.trim().length === 0) {
          valid = false;
        }
        break;
    }
    this.dataValid = valid;
  }

  cancelAddPaymentPage() {
    this.addPaymentPageDialog.visible = false;
    this.newPaymentPageData = null;
  }

  saveNewPaymentPageData() {
    this.addNewPaymentPage.emit(this.newPaymentPageData);
    this.addPaymentPageDialog.visible = false;
    this.initPaymentPageLinksPaymentTypes();
  }

  /**
   * Reset the donation amount list
   * TODO check if needed
   * @private
   */
  private resetDonationAmountValues() {
    /**
     * reset options for fixed amount if
     * custom amount is the selected option
     */
    if (this.paymentPageLinkDialog.linkType === 'DONATION') {
      if (this.paymentPageLinkData.amountType === 'CUSTOM') {
        this.paymentPageLinkData.donationAmountList = null;
        this.paymentPageLinkData.customAmountOption = null;
      }
    }
  }

  /**
   * Link-MenuItem was activated by enter or space
   * @param menuItem
   * @protected
   */
  protected linkMenuActivated(menuItem: MenuItem) {
    menuItem.command?.({
      originalEvent: null
    });
  }

}
